// src/pages/AboutPage.js
import React from 'react';
import useSEO from '../hooks/useSEO';

const AboutPage = () => {
  useSEO();

  return (
    <div style={{ padding: '40px', textAlign: 'center' }}>
      <h1>Sobre Verde Musgo Natural</h1>
      <p>Página em desenvolvimento - Por favor aguarde.</p>
    </div>
  );
};

export default AboutPage;
